import { makeActionCreator } from '@/Util/ReduxUtils'

export const TIMESTREAM_WARM_UP = 'TIMESTREAM_WARM_UP'
export const timestreamWarmUp = makeActionCreator(TIMESTREAM_WARM_UP, 'params')
